import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=4af1b12a&scoped=true"
var script = {}
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=4af1b12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1b12a",
  null
  
)

export default component.exports